import React from 'react';
// import './landingPage.css';
import Grid from '@mui/material/Grid'
import congVang from '../../assets/images/card2.jpg';

import { useTranslation } from 'react-i18next';
import '../../i18n' // Import i18n configuration

const IntroAbout = () => {
        const { t } = useTranslation(); // t is the translation function
        return (
            <section className="brown-section" id="aboutUS">
            <div className="container-fluid" >
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <img src={congVang} alt="logo" width="65%"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <h2 className="big-heading">{t('aboutPage:our-service.services')}</h2>
                    <ul className ='list'>
                        <li>{t('aboutPage:our-service.service-1')}</li>
                        <li>{t('aboutPage:our-service.service-2')}</li>
                        <li>{t('aboutPage:our-service.service-3')}</li>
                        <li>{t('aboutPage:our-service.service-4')}</li>
                        <li>{t('aboutPage:our-service.service-5')}</li>
                        <li>{t('aboutPage:our-service.service-6')}</li>
                        <li>{t('aboutPage:our-service.service-7')}</li>
                        <li>{t('aboutPage:our-service.service-8')}</li>
                        <li>{t('aboutPage:our-service.service-9')}</li>
                    </ul>
                    
                </Grid>
            </Grid>
            </div>
        </section>
)}

export default IntroAbout;


